import { eTemplatesTable } from './TemplatesTable.enum.ts';
import { tTemplatesTableHook } from './TemplatesTable.types.ts';
import { tComponent } from 'src/pages/WhatsappApi/WhatsappApi.types.ts';
import { useTranslation } from 'react-i18next';

export default function useTemplatesTable(): tTemplatesTableHook {
  const { t } = useTranslation('whatsappApi/whatsappApi');

  const getStatusPillClass = (status: eTemplatesTable) => {
    switch (status) {
      case eTemplatesTable.APPROVED:
        return 'bg-[#059669] text-white';
      case eTemplatesTable.PENDING:
        return 'bg-[#97a1af] text-white';
      case eTemplatesTable.REJECTED:
        return 'bg-[#ef4444] text-white';
      case eTemplatesTable.PAUSED:
        return 'bg-[#ea580c] text-white';
      case eTemplatesTable.APPEALED:
        return 'bg-[#3f85f6] text-white';
      case eTemplatesTable.DISABLED:
        return 'bg-[#97a1af] text-white opacity-50';
      case eTemplatesTable.DELETED:
        return 'bg-[#97a1af] text-white opacity-50';
      default:
        return 'bg-base-100 border border-base-content/30 text-base-content/70';
    }
  };

  const getTranslateStatus = (status: eTemplatesTable) => {
    switch (status) {
      case eTemplatesTable.APPROVED:
        return t('page.table.approved');
      case eTemplatesTable.PENDING:
        return t('page.table.pending');
      case eTemplatesTable.REJECTED:
        return t('page.table.rejected');
      case eTemplatesTable.PAUSED:
        return t('page.table.paused');
      case eTemplatesTable.APPEALED:
        return t('page.table.appealed');
      case eTemplatesTable.DISABLED:
        return t('page.table.disabled');
      case eTemplatesTable.DELETED:
        return t('page.table.deleted');
      default:
        return 'Unknown';
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}, ${day}, ${year}`;
  };

  function parseComponentIntoJson(component: string): tComponent[] {
    try {
      return JSON.parse(component) as tComponent[];
    } catch (error) {
      console.error('Error parsing component:', error);
      return [];
    }
  }

  return {
    getStatusPillClass,
    formatDate,
    parseComponentIntoJson,
    getTranslateStatus,
  };
}
